module.exports = __webpack_public_path__ + "img/double-quote.c2f367a.png";